
/* Heading animation */
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    document.body.classList.add("loaded");
  }, 300); // small delay for smooth effect
});


// --------------- Discount Button js ---------------------

(function () {
  'use strict';

  function domReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function getQuantityInput() {
    return (
      document.querySelector('input[name="quantity"]') ||
      document.querySelector('.quantity__input') ||
      document.querySelector('[data-quantity-input]') ||
      document.querySelector('input[id*="Quantity"]') ||
      document.querySelector('input[id*="quantity"]') ||
      document.querySelector('.qty input') ||
      document.querySelector('.product-form__quantity input') ||
      null
    );
  }

  function setQuantity(value) {
    var input = getQuantityInput();
    if (!input) {
      console.warn('[DiscountTab] Quantity input not found.');
      return;
    }
    var nativeSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    ).set;
    nativeSetter.call(input, value);
    input.dispatchEvent(new Event('input',  { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('blur',   { bubbles: true }));
  }

  function initDiscountTabs() {
    var wrappers = document.querySelectorAll('.dbt-wrapper');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var discountQty = parseInt(wrapper.dataset.discountQty, 10) || 2;
      var tabs = wrapper.querySelectorAll('.dbt-tab');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {

          // Deactivate all
          tabs.forEach(function (t) {
            t.classList.remove('active');
            t.setAttribute('aria-pressed', 'false');
          });

          // Activate clicked
          tab.classList.add('active');
          tab.setAttribute('aria-pressed', 'true');

          // Update qty
          if (tab.dataset.option === 'multi') {
            setQuantity(discountQty);
          } else {
            setQuantity(1);
          }
        });
      });
    });
  }

  domReady(initDiscountTabs);

  // Re-init after Theme Editor live reload
  document.addEventListener('shopify:section:load', initDiscountTabs);

})();